import { forEach } from 'lodash';
import { x, scrollTo } from '../_helpers';
import {
  isMobileDevice,
  isTabletDevice,
  isDesktopDevice,
  isLargeDesktopDevice,
} from '../_utilities/devices';
import { customResizeEvent, devices, videoDetailMainHook } from '../_helpers/constants';
import VideoPlayerIframe from './video-player-iframe';

export default class VideoDetails {
  constructor() {
    this.videoList = x('[js-related-videos]');
    this.videoMainContainer = x('[js-video-details-main-container]')[0];
    this.videoPlayer = new VideoPlayerIframe();
  }

  setMainVideo(element) {
    const videoDataset = element.dataset;
    const videoMain = x(videoDetailMainHook)[0];

    // video iframe data
    videoMain
      .querySelector('[js-meta-upload-date]')
      .setAttribute('content', videoDataset.contentDate);
    videoMain
      .querySelector('[js-meta-video-title]')
      .setAttribute('content', videoDataset.videoTitle);
    videoMain
      .querySelector('[js-meta-thumbnail-url]')
      .setAttribute('content', videoDataset.thumbnailUrl);
    videoMain.querySelector('[js-video-iframe]').setAttribute('title', videoDataset.videoTitle);
    videoMain.querySelector('[js-video-iframe]').setAttribute('src', videoDataset.iframeSrc);

    // video content data
    videoMain.querySelector('[js-video-context]').innerHTML = videoDataset.videoContext;
    videoMain.querySelector('[js-video-content-date-desktop]').innerHTML = videoDataset.contentDate;
    videoMain.querySelector('[js-video-content-date-mobile]').innerHTML = videoDataset.contentDate;
    videoMain.querySelector('[js-video-title]').innerHTML = videoDataset.videoTitle;

    // video social data
    const twitterEl = videoMain.querySelector('[js-twitter-share]');
    twitterEl.setAttribute('data-text', videoDataset.videoTitle);
    twitterEl.setAttribute('data-share-url', videoDataset.videoLink);

    const facebookEl = videoMain.querySelector('[js-facebook-share]');
    facebookEl.setAttribute('data-text', videoDataset.videoTitle);
    facebookEl.setAttribute('data-share-url', videoDataset.videoLink);

    const emailEl = videoMain.querySelector('[js-email-share]');
    const emailBody = `mailto:?subject=${videoDataset.videoTitle}&body=Enjoy the story ${videoDataset.videoTitle} - ${videoDataset.videoLink}`;
    emailEl.setAttribute('title', videoDataset.videoTitle);
    emailEl.setAttribute('href', emailBody);

    // replace video container for mobile devices
    if (isMobileDevice() || isTabletDevice()) {
      element
        .closest('.tc-related-videos__grid')
        .insertBefore(x(videoDetailMainHook)[0], element.nextSibling);
    }
    // Scroll to top on descktop devices
    if (isDesktopDevice() || isLargeDesktopDevice()) {
      scrollTo();
    }

    this.videoPlayer.checkVideoAvailability(true);
    // change page url
    if (window.history.replaceState) {
      //prevents browser from storing history with each change:
      window.history.replaceState({}, videoDataset.videoTitle, videoDataset.videoLink);
    }
  }

  setEventListners() {
    const self = this;
    forEach(this.videoList, (list) => {
      list.addEventListener('click', function (e) {
        if (e.target && e.target.closest('[js-related-video-item]') !== null) {
          const targetVideo = e.target.closest('[js-related-video-item]');
          self.setMainVideo.bind(self)(targetVideo);
        }
      });
    });
  }

  init() {
    this.setEventListners();
  }
}
